
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ImageBase from '@/components/atoms/ImageBase.vue'
import LoginPanel from '@/components/organisms/LoginPanel.vue'

/**
 * ログインページのフォーマット
 */
@Component({
  components: {
    ImageBase,
    LoginPanel,
  },
})
export default class LoginPage extends Vue {
  /** ログインパネル */
  @Ref()
  loginPanel!: LoginPanel

  /** ログインボタン押下時のイベント */
  @Prop()
  private eventLogin!: () => Promise<void>

  /** パスワードリマインダへのリンク */
  @Prop()
  private reminderLink?: string

  /** 仮ユーザログインへのリンク */
  @Prop()
  private activateLink?: string

  /**
   * ログインIDを取得する
   *
   * @returns ログインID
   */
  public loginId(): string {
    return this.loginPanel.loginId
  }

  /**
   * パスワードを取得する
   *
   * @returns パスワード
   */
  public password(): string {
    return this.loginPanel.password
  }
}
